import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Base: 44px tap-target on mobile (Apple HIG), 36px on >=md
        "flex h-11 md:h-9 w-full rounded-md border border-input bg-white px-3 py-1 text-base shadow-sm transition-colors",
        // File inputs (uncommon here, but keep consistent)
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // Placeholder + focus
        "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        // Disabled
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Avoid iOS Safari auto-zoom on focus (any text <16px triggers zoom)
        "text-base md:text-sm",
        // iOS date/time inputs: explicit min-height for tap area, but DO NOT set
        // appearance:none — it breaks the native picker on iOS Safari.
        "[&[type='date']]:min-h-[44px] [&[type='month']]:min-h-[44px] [&[type='time']]:min-h-[44px]",
        // Render the WebKit calendar/clock indicator with a comfortable hit area
        "[&::-webkit-calendar-picker-indicator]:opacity-100 [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:p-1",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
